module.exports = __webpack_public_path__ + "assets/img/logobg1.c138469a.png";